import { gsap } from 'gsap';
export default {
  init() {
      gsap.set('.block-double-cta', {autoAlpha:1});
      gsap.to(".block-double-cta", {
        scrollTrigger: {
          trigger : '.double-cta-box',
          start : 'top center'
        },
        autoAlpha: 1
      });
  },
  finalize() {}
}